/**
 * BuyNowButton，直接结算，点击元素本身触发
 * 
 * 注：要实现 variant id 和 quantity 动态变化，请在组件外部的逻辑中控制属性变化。
 *   例如要立即购买 10 件商品，使用 $("buy-now-button").attr("data-quantity", 10) 变更数量。
 * 
 * Attributes:
 * @param {String} data-variant-id 产品变体 ID
 * @param {String} data-quantity 购买数量，可选，默认为1
 * 
 * @example 
 * ```html
 * <script src="{{ 'component-buy-button.js' | asset_url }}" defer="defer"></script>
 * <buy-now-button data-variant-id="{{ product.first_available_variant.id }}" data-quantity="1" class="button round">
 *   Buy Now
 *   {%- render 'loading-spinner' -%}
 * </buy-now-button>
 * ```
 */
if (!customElements.get('buy-now-button')) {
    class BuyNowButton extends HTMLElement {
      // 标记
      _marks = {
        loading: "loading"
      };
  
      _shopify_features_script = document.querySelector("script[id='shopify-features']");
      _shopify_features_json = JSON.parse(this._shopify_features_script.innerHTML);
      _checkout_headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'authorization': 'Basic ' + btoa(this._shopify_features_json.accessToken)
      };
  
      get _variantId() { return this.getAttribute("data-variant-id") }
      get _quantity() { return this.getAttribute("data-quantity") ?? 1 }
  
      constructor() {
        super();
      }
  
      connectedCallback() {
        this.addEventListener('click', (e) => {
          this.checkout();
        });
      }

      /**
       * 直接结算
       */
      checkout() {
        const variantIds = this._variantId.split(',');
        const quantities = this._quantity.split(",");
  
        const defaultQuantity = quantities[0] || 1; // 默认数量为1，如果 quantities 为空
        if (variantIds.length !== quantities.length) {
          console.warn("变体ID与数量的数量不匹配，将使用相同的数量值。");
          quantities.length = variantIds.length; // 将数量数组的长度调整为与变体ID数组相同
          quantities.fill(defaultQuantity); // 用默认数量填充整个数组
        }
  
        let parmaString = '';
        for (let i = 0; i < variantIds.length; i++) {
          const variantId = variantIds[i];
          const quantity = quantities[i];
          if (i == 0) {
            parmaString = `${parmaString}${variantId}:${quantity}`;
          } else {
            parmaString = `${parmaString},${variantId}:${quantity}`;
          }
        }
  
        const cartRoute = window.routes?.cart_url ?? '/cart';;
        const checkoutUrl = `${cartRoute}/${parmaString}`;
        window.location.href = checkoutUrl;
      }

      startLoading() {
        this.setAttribute("aria-disabled", true);
        this.classList.add(this._marks.loading);
        this.elements.loadingSpinner?.classList.remove("hidden");
      }
  
      finishLoading() {
        this.removeAttribute("aria-disabled");
        this.classList.remove(this._marks.loading);
        this.elements.loadingSpinner?.classList.add("hidden");
      }
    }
  
    customElements.define('buy-now-button', BuyNowButton);
  }